//this action calls the GET all products, all in-stock products and product details API and then parses the dataFromAPI into a const function: getProductsSuccess, getProductDetailsSuccess & getProductsReleasedSuccess
import axios from "axios";
import {
  API_BASE_URL,
  PRODUCTS_FETCH,
  PRODUCTS_FETCH_POPULAR,
  PRODUCT_DETAIL_FETCH,
  BROWSE_ALL_PRODUCT,
  CART_ADD,
  PRODUCT_SEARCH_TO_KA_API,
  SORTING_SEARCH_RESULT,
  FILTERING_SEARCH_RESULT,
  CLEAR_BEFORE_FILTERING,
  FILTERING_HOMESCREEN,
  SAVING_SEARCH_QUERY,
  BROWSE_ALL_POPULAR_SEARCH,
  GET_SIZE_BASE_PRODUCT_ID,
  UPDATE_ACTIVE_PRODUCT,
  SEARCH_RESULT_LOAD_MORE,
  FILTERING_FROM_API,
  SORTING_SEARCH_RESULT_API,
  AUTH_TOKEN_KEY,
  GET_COLLECTION_VARIANTS,
  GET_ADDITIONAL_PRODUCT,
  EDITORS_CHOICE_PRODUCT,
  UPCOMING_PRODUCT,
  GET_COLLECTION_LIST,
  GET_FLASH_SALE_DETAIL,
  GET_FLASH_SALE_SETTING,
  PRODUCTS_FETCH_RELATED,
  PRODUCT_SEARCH_PENDING_TOGGLE,
  // GET_PRODUCT_DETAILS,
  GET_MOST_SEARCH_RESULTS,
  FETCHING_MOST_SEARCH_RESULTS,
  MOST_SEARCH_RESULTS_ERROR,
  SEARCH_OPEN,
  ALL_HANDBAG_CONDITION_PENDING,
  ALL_HANDBAG_CONDITION_FULFILLED,
  ALL_HANDBAG_CONDITION_REJECTED,
  USER_RECENT_SEARCH,
  PRODUCT_SEARCH_ES_URI,
  FECTH_SHOES_SALE_HISTORY_DATA,
  SEARCH_STATE,
  GET_TRENDING_PRODUCT,
  GET_TOP_SELLING_PRODUCT,
  POST_CONCIERGE,
  GET_CONCIERGE,
  PUT_CONCIERGE,
  GET_SPINNING_WHEEL,
  GET_SPINNING_WHEEL_PRIZE,
  POST_SPINNING_WHEEL,
  GET_COLLECTION_BY_SLUG,
  GET_COLLECTION_PRODUCT_LIST,
  SECTION_DETAILS,
  CLICK_MENU_NAVBAR,
  REQUEST_TO_ELASTIC_SEARCH,
  FETCH_COLLECTION_PRODUCT_LIST,
  RECOMMENDED_PRODUCT,
  COLLECTION_HOMEPAGE,
  GET_ALL_COLLECTION_BY_SLUG,
  BRAND_PRODUCT,
  GET_TICKET_LIST_SETTING
} from "../constants/";

import fetch from "../utils/Api";
import uuidv4 from "uuid/v4";
import AWS from "aws-sdk";

const ENDPOINT = "/products";
// const getProductProcess = bool => ({
//  type:FETCH_PRODUCTS,
//  payload:bool
// })

// const getProductError=(err)=>({
//  type:FETCH_PRODUCTS_ERROR,
//  payload:err
// })

// export const getProductDetailsSuccess = productDetails => ({
//  type: GET_PRODUCT_DETAILS,
//  payload: productDetails
// })
// export const getProductsReleasedSuccess = productsInStock => ({
//  type: GET_PRODUCTS_RELEASED,
//  payload: productsInStock
// })

export const doChangeIsOpen = (boolean) => {
  return { type: SEARCH_OPEN, boolean };
};

// Search state
export const searchState = (payload) => {
  return {
    type: SEARCH_STATE,
    searchInput: payload,
  };
};

//click menu navbar

export const clickMenuNavbar = (boolean) => ({
  type: CLICK_MENU_NAVBAR,
  payload: boolean,
});


export const getCollectionHomepageAsync = (category) => {
  return {
    type: COLLECTION_HOMEPAGE,
    payload: fetch()
      .get(`${API_BASE_URL}/collections`, { params: { highlight: 'homepage', category } })
      .then(res => {
        return res.data
      })
      .catch(e => console.log(e))
  }
}

export const putConcierge = (id, payload) => {
  return {
    type: PUT_CONCIERGE,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY),
    })
      .put(`${API_BASE_URL}/users/concierge/${id}`, payload)
      .then((res) => {
        return { ...res.data };
      }),
  };
};
export const getSpinningWheel = () => ({
  type: GET_SPINNING_WHEEL,
  payload: fetch({
    Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .get(`${API_BASE_URL}/spinning-wheel`)
    .then((res) => {
      return res.data;
    }),
});

export const getSpinningWheelPrize = (id) => ({
  type: GET_SPINNING_WHEEL_PRIZE,
  payload: fetch({
    Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .get(`${API_BASE_URL}/users/spinning-wheel/${id}/prizes`)
    .then((res) => {
      return res.data;
    }),
});

export const postSpinningWheel = (payload) => ({
  type: POST_SPINNING_WHEEL,
  payload: fetch({
    Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY),
    "Content-Type": "application/json",
  })
    .post(`${API_BASE_URL}/users/spinning-wheel/generate-prize`, payload)
    .then((res) => {
      return res;
    })
    .catch((e) => e),
});

// export const doFetchMostSearchResults = (payload) => ({
//   type:GET_MOST_SEARCH_RESULTS,
//   payload: axios.get(`${API_BASE_URL}/products/search`, payload)
//   .then((res)=>res.data, pay)
// })

export const isFetch = (bool) => ({
  type: FETCHING_MOST_SEARCH_RESULTS,
  payload: bool,
});

export const onSuccess = (res, keyword) => ({
  type: GET_MOST_SEARCH_RESULTS,
  payload: res,
  keyword: keyword,
});

const transformElasticProduct = (p) => {
  const product = {
    id: uuidv4(),
    name: p.product_name,
    brand:
      p.brands && p.brands.length
        ? { id: uuidv4(), name: p.brands[p.brands.length - 1], flat: p.brands }
        : typeof p.product === "object"
          ? p.product.brand
          : null,
  };
  let product_variant_images = [];
  if (p.image_url || p.product_variant_images) {
    const image_attribute = p.product_variant_images;
    product_variant_images = [
      {
        id: uuidv4(),
        product_variant_id:
          image_attribute && image_attribute.length > 0
            ? image_attribute[0].id
            : p.id,
        URL:
          image_attribute && image_attribute.length > 0
            ? image_attribute[0].URL
            : p.image_url,
        signed_url:
          image_attribute && image_attribute.length > 0
            ? image_attribute[0].signed_url
            : p.signed_url,
      },
    ];
  }
  let latest_price = null;
  if (p.latest_price) {
    latest_price = {
      id: uuidv4(),
      product_variant_id: p.id,
      asking_price:
        typeof p.latest_price === "object"
          ? p.latest_price.asking_price
          : p.latest_price,
    };
  }
  return {
    ...p,
    product,
    product_variant_images,
    latest_price,
  };
};

export const doFetchMostSearchResults = (payload) => {
  return (dispatch) => (
    dispatch(isFetch(true)),
    // axios.get(`${API_BASE_URL}/products/search`, payload)
    axios
      .get(`${PRODUCT_SEARCH_ES_URI}`, payload)
      .then((res) => {
        const responseData = {
          ...res.data,
          data: {
            ...res.data.data,
            data: res.data.data.data.map(transformElasticProduct),
          },
        };
        dispatch(onSuccess(responseData, payload.params.keyword));
        dispatch(isFetch(false));
      })
      .catch((err) => {
        dispatch({
          type: MOST_SEARCH_RESULTS_ERROR,
          payload: err,
          keyword: payload.params.keyword,
        });
        dispatch(isFetch(false));
      })
  );
};

export const doFetchProducts = (query = {}) => ({
  type: PRODUCTS_FETCH,
  payload: axios
    .get(`${API_BASE_URL}${ENDPOINT}`, query)
    .then((res) => res.data),
});

export const doFetchPopularProducts = (query = {}) => ({
  type: PRODUCTS_FETCH_POPULAR,
  payload: axios.get(PRODUCT_SEARCH_ES_URI, query).then((res) => {
    const { current_page, last_page, next_page_url, total } = res.data.data;
    let data = {
      data: {
        ...res.data.data,
        data: res.data.data.data.map(transformElasticProduct),
        total: res.data.data.total,
      },
      status: res.data.status_code,
      message: res.data.message,
    };
    return data;
  }),
});

export const doFetchRelatedProducts = (productId, query = {}) => ({
  type: PRODUCTS_FETCH_RELATED,
  //payload: axios.get(`${API_BASE_URL}${ENDPOINT}/recommendation/${productId}`, query)
  payload: axios
    .get(`${API_BASE_URL}${ENDPOINT}/${productId}/recommendation`, query)
    .then((res) => res.data),
});

export const doFetchProductDetails = (productId, query = {}) => ({
  type: PRODUCT_DETAIL_FETCH,
  payload: axios
    .get(`${API_BASE_URL}${ENDPOINT}/${productId}`, { params: { ...query } })
    .then((res) => res.data),
});

export const doFetchVintageDetails = (productId, query = {}) => ({
  type: PRODUCT_DETAIL_FETCH,
  payload: axios
    .get(`${API_BASE_URL}${ENDPOINT}/${productId}/browse`, {
      params: { ...query },
    })
    .then((res) => res.data),
});

export const postConcierge = (payload) => {
  let formData = new FormData();
  formData.append("name", payload.name);
  formData.append("phone_number", payload.phone_number);
  formData.append("image", payload.image);
  formData.append("shipping_id", payload.shipping_id);
  formData.append("product_name", payload.product_name);
  payload.condition && formData.append("condition", payload.condition);
  payload.condition2 && formData.append("condition2", payload.condition2);

  return {
    type: POST_CONCIERGE,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY),
      "Content-Type": "multipart/form-data",
    })
      .post(`${API_BASE_URL}/users/concierge`, formData)
      .then((res) => {
        return { ...res.data };
      }),
  };
};

export const getConcierge = () => {
  return {
    type: GET_CONCIERGE,
    payload: fetch({
      Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY),
    })
      .get(`${API_BASE_URL}/users/concierge`)
      .then((res) => {
        return res.data;
      }),
  };
};

export const doAddToCart = (payload) => ({
  type: CART_ADD,
  payload,
});

export const doBrowseAll = (query, status_action = "") => {
  return (dispatch) => {
    dispatch({ type: PRODUCT_SEARCH_PENDING_TOGGLE, payload: true });

    dispatch({
      type: "BROWSE_ALL_PRODUCT_PENDING",
    });

    axios
      .get(PRODUCT_SEARCH_ES_URI, query)
      .then((res) => {
        const { current_page, last_page, next_page_url, total } = res.data.data;
        let data = {
          response: {
            data: {
              data: res.data.data.data.map(transformElasticProduct),
              total: res.data.data.total,
            },
            status: res.data.status_code,
            message: res.data.message,
          },
          params: query.params,
        };

        dispatch({
          type: "BROWSE_ALL_PRODUCT_FULFILLED",
          payload: data,
          keywordSearch: "Browse All",
          pagination: res.data.data,
          status_action,
          caseSorting: query.params.sort_by,
        });
      })
      .catch((err) => {
        dispatch({
          type: "BROWSE_ALL_PRODUCT_REJECTED",
          params: query.params,
        });
      });
  };
};

export const getCollectionVariants = (idCollection, params = {}) => ({
  type: GET_COLLECTION_VARIANTS,
  payload: axios
    .get(`${API_BASE_URL}/${idCollection}/product_variants`, params)
    .then((res) => {
      return res.data;
    })
    .catch((err) => err),
});

// ACTION SEARCH TO API
export const searchProductSuccess = (
  product_result,
  searchKeyword,
  pagination,
  sort_by = "most_popular"
) => ({
  type: PRODUCT_SEARCH_TO_KA_API,
  payload: product_result,
  keywordSearch: searchKeyword,
  pagination,
  caseSorting: sort_by,
});

// ACTION SEARCH TO API
export const searchProductSuccessModal = (
  product_result,
  searchKeyword,
  pagination,
  sort_by = "most_popular"
) => ({
  type: "PRODUCT_SEARCH_TO_KA_API_MODAL",
  payload: product_result,
  keywordSearch: searchKeyword,
  pagination,
  caseSorting: sort_by
});

export const searchProduct = (payload, status) => {
  const { searchKeyword, category } = payload;
  const browseAll = "Browse All";
  const withoutKeyword = searchKeyword == "";

  let manipulate = searchKeyword.replace(/\+/g, " ");
  let query = {};
  if (status === "SELLING") {
    query = {
      params: {
        keyword: withoutKeyword ? undefined : manipulate,
        category,
        _scope: "selling",
        // availables: true
      },
    };
  }
  if (status !== "SELLING") {
    query = {
      params: {
        category,
        keyword: withoutKeyword ? undefined : manipulate,
        availables: true,
        per_page: 52,
        sort_by: payload.sort_by,
      },
    };
  }

  return (dispatch) => new Promise((resolve, reject) => {
    dispatch({ type: PRODUCT_SEARCH_PENDING_TOGGLE, payload: true });
    axios
      .get(PRODUCT_SEARCH_ES_URI, query)
      .then((res) => {
        const responseData = {
          ...res.data,
          data: {
            ...res.data.data,
            data: res.data.data.data.map(transformElasticProduct),
          },
        };
        const {
          current_page,
          last_page,
          next_page,
          next_page_url,
          product_categories,
          total,
        } = responseData.data;
        const pagination = {
          product_categories,
          current_page,
          last_page,
          next_page_url: next_page_url || next_page,
          next_page,
          total,
        };
        resolve(
          dispatch(
            searchProductSuccess(
              responseData.data.data,
              withoutKeyword ? browseAll : searchKeyword,
              pagination,
              payload.sort_by
            )
          )
        );
      })
      .catch((err) => {
        reject(
          dispatch(
            searchProductSuccess(err, withoutKeyword ? browseAll : searchKeyword)
          )
        );
      });

    dispatch({ type: "CLEAR_REDIRECT_SEARCH", optionValue: "FIRST_REDIRECT" });
  })
}

export const searchModalProduct = (payload, status) => {
  const { searchKeyword, category } = payload;
  const browseAll = "Browse All";
  const withoutKeyword = searchKeyword == "";

  let manipulate = searchKeyword.replace(/\+/g, " ");
  let query = {};
  if (status === "SELLING") {
    query = {
      params: {
        keyword: withoutKeyword ? undefined : manipulate,
        category,
        // availables: true
      },
    };
  }
  if (status !== "SELLING") {
    query = {
      params: {
        category,
        keyword: withoutKeyword ? undefined : manipulate,
        availables: true,
        per_page: 52,
        sort_by: payload.sort_by
      }
    };
  }

  return (dispatch) => {
    dispatch({ type: "PRODUCT_SEARCH_PENDING_TOGGLE_MODAL", payload: true });
    axios
      .get(PRODUCT_SEARCH_ES_URI, query)
      .then((res) => {
        const responseData = {
          ...res.data,
          data: {
            ...res.data.data,
            data: res.data.data.data.map(transformElasticProduct),
          },
        };
        const {
          current_page,
          last_page,
          next_page,
          next_page_url,
          product_categories,
          total,
        } = responseData.data;
        const pagination = {
          product_categories,
          current_page,
          last_page,
          next_page_url: next_page_url || next_page,
          next_page,
          total,
        };
        dispatch(
          searchProductSuccessModal(
            responseData.data.data,
            withoutKeyword ? browseAll : searchKeyword,
            pagination,
            payload.sort_by
          )
        );
      })
      .catch((err) => {
        dispatch(
          searchProductSuccessModal(
            err,
            withoutKeyword ? browseAll : searchKeyword
          )
        );
      });

    dispatch({
      type: "CLEAR_REDIRECT_SEARCH_MODAL",
      optionValue: "FIRST_REDIRECT",
    });
  };
};

export const searchToLoadMore = (params, status) => {
  let { keyword, ...otherParams } = params;
  let query = {};
  if (status === "SELLING") {
    query = {
      params: {
        ...otherParams,
        // availables: true
      },
    };
  }
  if (status !== "SELLING") {
    query = {
      params: {
        ...otherParams,
        availables: true,
      },
    };
  }
  if (keyword !== "Browse All") {
    let manipulate = keyword.replace(/\+/g, " ");
    query.params.keyword = manipulate;
  }

  return (dispatch) => {
    dispatch({ type: PRODUCT_SEARCH_PENDING_TOGGLE, payload: true });
    // axios.get(`${API_BASE_URL}/products/search`, query)
    axios
      .get(`${PRODUCT_SEARCH_ES_URI}`, query)
      .then((res) => {
        const responseData = {
          ...res.data,
          data: {
            ...res.data.data,
            data: res.data.data.data.map(transformElasticProduct),
          },
        };
        dispatch({
          type: SEARCH_RESULT_LOAD_MORE,
          payload: { ...responseData, params },
        });
      })
      .catch((err) => {
        dispatch({ type: SEARCH_RESULT_LOAD_MORE, payload: err });
      });
  };
};

export const getSizeBaseOnProductIdSuccess = (size_list) => ({
  type: GET_SIZE_BASE_PRODUCT_ID,
  payload: size_list,
});

// ACTION GET SIZE BASE ON PRODUCT_ID
export const getSizeBaseOnProductId = (productId) => {
  return (dispatch) =>
    axios
      .get(`${API_BASE_URL}/sizes/variants/${productId}`)
      .then((res) => {
        dispatch(getSizeBaseOnProductIdSuccess(res.data));
      })
      .catch((err) => dispatch(getSizeBaseOnProductIdSuccess(err)));
};

// Sort to API
export const sortingSearchResultAPI = (
  params,
  query = {},
  status_action = ""
) => {
  return (dispatch) => {
    if (status_action === "")
      dispatch({ type: "EMPTY_SORTING_SEARCH_RESULT_API" });

    dispatch({
      type: "SORTING_SEARCH_RESULT_API_PENDING",
    });
    axios
      .get(`${PRODUCT_SEARCH_ES_URI}?${params}`, query)
      .then((response) => {
        let data = {
          res: {
            data: {
              data: response.data.data.data.map(transformElasticProduct),
              total: response.data.data.total,
            },
            status_code: response.data.status_code,
            message: response.data.message,
          },
          pagination: response.data.data,
          status_action,
          params: query.params,
        };

        dispatch({
          type: "SORTING_SEARCH_RESULT_API_FULFILLED",
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "SORTING_SEARCH_RESULT_API_REJECTED",
          error,
          params: query.params,
        });
      });
  };
};
//

export const sortingSearchResult = (
  paramsRoute,
  query = {},
  status_action
) => ({
  type: SORTING_SEARCH_RESULT,
  payload: fetch()
    .get(`products/browse?${paramsRoute}`, query)
    .then((response) => {
      const {
        current_page,
        last_page,
        next_page_url,
        total,
      } = response.data.data;
      let pagination = {
        current_page,
        last_page,
        next_page_url,
        total,
      };
      const result = {
        sort_by: query.params.sort_by,
        data: response.data,
        status_action,
        pagination,
      };

      return result;
    })
    .catch((error) => error),
});

// FILTER TO API

export const doFilteringSearchToApi = (
  params,
  query = {},
  status_action = ""
) => {
  return (dispatch) => {
    if (status_action === "")
      dispatch({ type: "EMPTY_RESULT_FILTERING_FROM_API" });

    dispatch({
      type: "FILTERING_FROM_API_PENDING",
    });
    axios
      .get(`${PRODUCT_SEARCH_ES_URI}?${params}`, query)
      .then((response) => {
        let data = {
          res: {
            data: {
              data: response.data.data.data.map(transformElasticProduct),
              total: response.data.data.total,
            },
            status_code: response.data.status_code,
            message: response.data.message,
          },
          pagination: response.data.data,
          status_action,
          params: query.params,
        };

        dispatch({
          type: "FILTERING_FROM_API_FULFILLED",
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "FILTERING_FROM_API_REJECTED",
          error,
          params: query.params,
        });
      });
  };
};

export const saveSearchQueriesSuccess = (message) => ({
  type: SAVING_SEARCH_QUERY,
  payload: message,
});

export const saveSearchQueries = (querySearch) => {
  return (dispatch) =>
    axios
      .post(`${API_BASE_URL}/products/search/save`, querySearch)
      .then((res) => {
        dispatch(saveSearchQueriesSuccess(res));
      })
      .catch((err) => {
        dispatch(saveSearchQueriesSuccess(err));
      });
};

export const filteringHomeScreenSuccess = (result) => ({
  type: FILTERING_HOMESCREEN,
  payload: result,
});

export const filteringHomeScreen = (params) => {
  let brands = `brands=${params}`;
  // let sizes = `sizes=${params.sizeId}`
  // let genders = `genders=${params.gender}`
  // let prices = `start_price=${params.minPrice}&end_price=${params.maxPrice}`
  // let final_filters = `${brands}&${sizes}&${genders}&${prices}`
  return (dispatch) =>
    axios
      .get(`${API_BASE_URL}/products/filter?${brands}`)
      .then((res) => {
        dispatch(filteringHomeScreenSuccess(res.data));
      })
      .catch((err) => console.log(err));
};

export const filteringSearchResult = (params) => ({
  type: FILTERING_SEARCH_RESULT,
  payload: params,
});

export const clearBeforeFiltering = () => ({
  type: CLEAR_BEFORE_FILTERING,
  payload: true,
});

export const doFetchPopularSearch = (query) => ({
  type: BROWSE_ALL_POPULAR_SEARCH,
  payload: axios
    .get(`${API_BASE_URL}${ENDPOINT}/popular/search`, query)
    .then((res) => {
      return res.data;
    }),
});

export const updateActiveId = (id) => ({
  type: UPDATE_ACTIVE_PRODUCT,
  payload: id,
});

export const getAdditionalPage = (type, params = {}) => ({
  type: GET_ADDITIONAL_PRODUCT,
  payload: axios
    .get(`${API_BASE_URL}${ENDPOINT}/${type}`, params)
    .then((res) => res.data),
});

export const editorsChoicePage = (type, params = {}) => ({
  type: EDITORS_CHOICE_PRODUCT,
  payload: axios
    .get(`${API_BASE_URL}${ENDPOINT}/${type}`, params)
    .then((res) => res.data),
});

export const upcomingProductPage = (params = {}) => ({
  type: UPCOMING_PRODUCT,
  payload: axios
    .get(`${API_BASE_URL}${ENDPOINT}/unreleased`, params)
    .then((res) => res.data),
});

export const getCollectionList = (params = {}) => ({
  type: GET_COLLECTION_LIST,
  payload: axios
    .get(`${API_BASE_URL}/collections`, params)
    .then((res) => res.data),
});

export const getFlashSaleCollectionList = (category, value) => ({
  type: GET_FLASH_SALE_DETAIL,
  payload: axios
    .get(
      `${API_BASE_URL}/collections/${category}/${value}?pre_verified=true&sort_by=price_asc`
    )
    .then((res) => res.data),
});

export const getFlashSaleSetting = () => ({
  type: GET_FLASH_SALE_SETTING,
  payload: axios
    .get(`${API_BASE_URL}/settings?name=flash_sale_collections`)
    .then((res) => res.data),
});

export const getHandbagConditions = (productId) => {
  return (dispatch) => {
    dispatch({
      type: ALL_HANDBAG_CONDITION_PENDING,
    });
    axios
      .get(`${API_BASE_URL}/products/${productId}/listings`)
      .then((res) => {
        dispatch({
          type: ALL_HANDBAG_CONDITION_FULFILLED,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: ALL_HANDBAG_CONDITION_REJECTED,
          payload: err,
        });
      });
  };
};

export const getRecentSearch = (category = "sneakers") => ({
  type: USER_RECENT_SEARCH,
  payload: fetch({
    Authorization: "Bearer " + localStorage.getItem(AUTH_TOKEN_KEY),
  })
    .get("products/recent/search", {
      params: {
        category,
        limit: 6,
      },
    })
    .then((res) => res.data),
});

// Fetch Sale History Data
export const getSaleHistory = (ids, condition, interval) => ({
  type: FECTH_SHOES_SALE_HISTORY_DATA,
  payload: fetch()
    .get(`/products/sale-history`, {
      params: {
        ids,
        condition,
        interval,
      },
    })
    .then((res) => res.data),
});

export const getTrendingProduct = (params = {}) => ({
  type: GET_TRENDING_PRODUCT,
  payload: fetch()
    .get("products/trends", params)
    .then((res) => res.data),
});

export const getTopSellingProduct = (params = {}, category) => ({
  type: GET_TOP_SELLING_PRODUCT,
  payload: fetch()
    .get("products/top-selling", params)
    .then((res) => res.data),
});

export const getCollectionBySlug = (category, slug) => ({
  type: category === "all" ? GET_ALL_COLLECTION_BY_SLUG : GET_COLLECTION_BY_SLUG,
  payload: fetch()
    .get(`collections/${category}/${slug}`)
    .then((res) => res.data),
});

export const resetCollectionStateData = () => ({
  type: `${GET_ALL_COLLECTION_BY_SLUG}_RESET`,
})

export const getCollectionProduct = (id, payload) => ({
  type: GET_COLLECTION_PRODUCT_LIST,
  payload: fetch()
    .get(`collections/${id}/product_variants`, { params: payload })
    .then((res) => res.data),
});

export const recordCollectionActivity = (payload) => ({
  payload: fetch()
    .post("collections/activity", payload)
    .then((res) => res.data)
})

export const getDetailSection = (category, type) => ({
  type: SECTION_DETAILS,
  payload: fetch()
    .get(`${category}-sections/${type}`)
    .then((res) => res.data),
});

export const postRequestToElasticSearch = (productVariantId) => ({
  type: REQUEST_TO_ELASTIC_SEARCH,
  payload: fetch().post(`products/${productVariantId}/sns`)
    .then(res => res.data)
})

export const fetchCollectionProduct = (
  payload,
  filterQueries = ""
) => {
  return {
    type: `${FETCH_COLLECTION_PRODUCT_LIST}`,
    payload: axios.get(`${PRODUCT_SEARCH_ES_URI}?${filterQueries}`, { params: payload })
      .then(res => {
        const responseData = {
          ...res.data,
          data: {
            ...res.data.data,
            data: res.data.data.data.map(transformElasticProduct),
          }
        };
        return responseData
      })
      .catch(err => {
        dispatch({
          type: `${FETCH_COLLECTION_PRODUCT_LIST}_REJECTED`,
          payload: err
        });
      })
  }
};

export const saveCollectionSort = (sort_by) => ({
  type: "SAVE_COLLECTION_SORT",
  data: sort_by
})

export const getRecommendedProduct = (userId, category = 'sneakers', filterQueries = '', isHomepage = false) => {
  return (dispatch) => {
    dispatch({
      type: `${RECOMMENDED_PRODUCT}_PENDING`,
    });

    const personalizeruntime = new AWS.PersonalizeRuntime({
      apiVersion: "2018-05-22",
      accessKeyId: "AKIARCUVDGF4HLX2E4OY",
      secretAccessKey: "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",
      region: "ap-southeast-1",
    });

    const params = {
      campaignArn:
        "arn:aws:personalize:ap-southeast-1:074400870776:campaign/Personalize3" /* required */,
      context: {},
      numResults: isHomepage ? '0' : '100',
      userId: String(userId),
    };

    let arrayOfId = [];

    personalizeruntime.getRecommendations(params, function (err, data) {
      if (err) {
        dispatch({
          type: `${RECOMMENDED_PRODUCT}_ERROR`,
          payload: err
        });
      } else {
        const idsArray =
          data.itemList &&
          data.itemList.length > 0 &&
          data.itemList.map((list) => list.itemId);
        const productIds = isHomepage ? idsArray.slice(0, 11) : idsArray;
        const ids = productIds.length > 0 ? productIds.join(",") : "";

        // UNCOMENT FOR TESTING
        // const ids = "254,937" 

        axios
          .get(`${PRODUCT_SEARCH_ES_URI}?ids=${ids}&${filterQueries}`, { params: { category, availables: true } })
          .then(({ data }) => {
            const { data: payload = {} } = data || {}
            dispatch({
              type: `${RECOMMENDED_PRODUCT}_FULFILLED`,
              payload
            });
          })
          .catch(err => {
            dispatch({
              type: `${RECOMMENDED_PRODUCT}_ERROR`,
              payload: err
            });
          })
      }
    });
  };
};

export const doFetchBrandsProduct = (stringParams = "") => ({
  type: BRAND_PRODUCT,
  payload: axios.get(PRODUCT_SEARCH_ES_URI + stringParams).then((res) => {
    const { current_page, last_page, next_page_url, total } = res.data.data;
    let data = {
      data: {
        ...res.data.data,
        data: res.data.data.data.map(transformElasticProduct),
        total: res.data.data.total,
      },
      status: res.data.status_code,
      message: res.data.message,
    };
    return data;
  }),
});

export const doFetchBrandsPageBanner = async (category) => {
  return axios.get(API_BASE_URL + "/brands?category=" + category)
};

export const getTicketListSetting = () => ({
  type: GET_TICKET_LIST_SETTING,
  payload: axios
    .get(`${API_BASE_URL}/settings?name=variant_tickets`)
    .then((res) => res.data),
});